import React from 'react';
import './Section.css';

const Section = ({ imageSrc, title, description1, description2, description }) => (
  <section className="p1-container">
    <div className="p1-image-container">
      <img
        src={imageSrc}
        alt="Section Image"
        className="p1-image"
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </div>
    <div className="p1-text-container">
      <div className="p1-text-content">
        <h2>{title}</h2>
        {description ? (
          <p style={{ maxWidth: '90ch', margin: '1rem 0', lineHeight: '1.6', whiteSpace: 'pre-line' }}>
            {description}
          </p>
        ) : (
          <>
            <p style={{ maxWidth: '90ch', margin: '1rem 0', lineHeight: '1.6' }}>
              {description1}
            </p>
            <p style={{ maxWidth: '90ch', margin: '1rem 0', lineHeight: '1.6' }}>
              {description2}
            </p>
          </>
        )}
      </div>
    </div>
  </section>
);

export default Section;